import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';

class Counter {
  constructor() {
    this.init();
  }

  init() {
    this.stats = document.querySelector("#stats");

    if (!this.stats) {
      return;
    }

    this.runAnimation();
  }

  runAnimation() {
    const controllerStats = new ScrollMagic.Controller();

    const numbers = document.querySelectorAll('.field-number');
    const timeAnimation = 4;

    const scene = new ScrollMagic.Scene({
      triggerElement: "#stats",
      reverse: false,
      offset: -330,
    }).addTo(controllerStats)
        // .addIndicators({name: "stats start"}); // add indicators (requires plugin);

    const timeline = new TimelineMax();

    [...numbers].forEach((single) => {
      const distance = {score: 0};
      const singleVal = single.dataset.number;
      const parseVal = parseFloat(singleVal.replace(/,/g, ''));

      timeline.to(distance, timeAnimation, {
        score: parseVal,
        onUpdate: function () {
          single.innerHTML = numberWithCommas(Math.ceil(distance.score));
        }
      }, 0);
    });

    scene.setTween(timeline);

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

  }


}

export {Counter};